import { PageUrlKey } from '@/entities/page-url-key';

/**
 * Maps PageUrlKey enum values to their corresponding route paths
 */
export function mapPageUrlKeyToPath(pageUrlKey: PageUrlKey): string {
  switch (pageUrlKey) {
    case PageUrlKey.DEFAULT_LANDING_PAGE:
      return '/';
    case PageUrlKey.PROJECTS:
      return '/projects';
    case PageUrlKey.PROJECT:
      return '/project';
    case PageUrlKey.ALERTS:
      return '/alerts';
    case PageUrlKey.ALERTS_EXPORT:
      return '/alerts/export';
    case PageUrlKey.BENCHMARK:
      return '/benchmark';
    case PageUrlKey.CAPACITY_TEST:
      return '/capacity-test';
    case PageUrlKey.CHANGELOG:
      return '/changelog';
    case PageUrlKey.DATA_COMPATIBILITY:
      return '/data-compatibility';
    case PageUrlKey.DATA_EXPLORER:
      return '/data-explorer';
    case PageUrlKey.DOCUMENTS:
      return '/documents';
    case PageUrlKey.OVERVIEW:
      return '/overview';
    case PageUrlKey.PCS:
      return '/pcs';
    case PageUrlKey.DETAILS:
      return '/details';
    case PageUrlKey.SITE_MAP:
      return '/site-map';
    case PageUrlKey.TASKS:
      return '/tasks';
    case PageUrlKey.WARRANTY:
      return '/warranty';
    case PageUrlKey.ALERT_NOTIFICATIONS:
      return '/alert-notifications';
    case PageUrlKey.CONTRACTS:
      return '/subscriptions';
    case PageUrlKey.COMMUNICATION:
      return '/communication';
    case PageUrlKey.SITEVIEW:
      return '/siteview';
    case PageUrlKey.TRUST_CENTER:
      return '/trust-center';
    case PageUrlKey.USER_PREFERENCES:
      return '/account/user-preferences';
    default:
      return '/';
  }
}
